import { Component, Input } from '@angular/core';

/**
 * Generated class for the BlocoBotoesRedeSocialComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'bloco-botoes-rede-social',
  templateUrl: 'bloco-botoes-rede-social.html'
})
export class BlocoBotoesRedeSocialComponent {

  @Input() linkFacebook: string;
  @Input() linkTwitter: string;


  constructor() {

  }

  public isFacebookDispinivel():boolean {
    return this.linkFacebook && this.linkFacebook != "";
  }

  public isTwitterDisponivel():boolean {
    return this.linkTwitter && this.linkTwitter != "";
  }

}



// WEBPACK FOOTER //
// ./src/components/bloco-botoes-rede-social/bloco-botoes-rede-social.ts